<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Dashboard
            </h2>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto px-6 lg:px-8">
                <div class="grid gap-6 md:grid-cols-4">
                    <InertiaLink
                        class="transition-colors w-full bg-white shadow-md rounded p-6 text-center hover:shadow-lg hover:bg-gray-700 hover:text-white"
                        :href="route('intern.import')"
                    >
                        <font-awesome-icon
                            :icon="['fad', 'database']"
                            size="4x"
                            class="text-glm-red"
                        ></font-awesome-icon>

                        <div class="mt-6">
                            Upload Data
                        </div>
                    </InertiaLink>

                    <InertiaLink
                        class="transition-colors w-full bg-white shadow-md rounded p-6 text-center hover:shadow-lg hover:bg-gray-700 hover:text-white"
                        :href="route('intern.samples')"
                    >
                        <font-awesome-icon
                            :icon="['fad', 'layer-group']"
                            size="4x"
                            class="text-glm-red"
                        ></font-awesome-icon>

                        <div class="mt-6">
                            Samples
                        </div>
                    </InertiaLink>

                    <InertiaLink
                        class="transition-colors w-full bg-white shadow-md rounded p-6 text-center hover:shadow-lg hover:bg-gray-700 hover:text-white"
                        :href="route('intern.splits')"
                    >
                        <font-awesome-icon
                            :icon="['fad', 'folders']"
                            size="4x"
                            class="text-glm-red"
                        ></font-awesome-icon>

                        <div class="mt-6">
                            Splits
                        </div>
                    </InertiaLink>

                    <InertiaLink
                        class="transition-colors w-full bg-white shadow-md rounded p-6 text-center hover:shadow-lg hover:bg-gray-700 hover:text-white"
                        :href="route('intern.variables')"
                    >
                        <font-awesome-icon
                            :icon="['fad', 'columns']"
                            size="4x"
                            class="text-glm-red"
                        ></font-awesome-icon>

                        <div class="mt-6">
                            Variables
                        </div>
                    </InertiaLink>

                    <InertiaLink
                        class="transition-colors w-full bg-white shadow-md rounded p-6 text-center hover:shadow-lg hover:bg-gray-700 hover:text-white"
                        :href="route('intern.publications')"
                    >
                        <font-awesome-icon
                            :icon="['fad', 'file']"
                            size="4x"
                            class="text-glm-red"
                        ></font-awesome-icon>

                        <div class="mt-6">
                            Publications
                        </div>
                    </InertiaLink>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import Welcome from '@/Jetstream/Welcome'

export default {
    components: {
        AppLayout,
        Welcome,
    },
}
</script>
